import { Stack } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import { TFunction } from 'i18next';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

interface DepositCheckRejectedViewProps {
  errors: string[];
  translatedText: TFunction<'rdc', undefined>;
  handleDoneAction: () => void;
}

const DepositCheckRejectedView = ({
  errors,
  translatedText,
  handleDoneAction,
}: DepositCheckRejectedViewProps) => {
  const { outcome } = rdcStrings;

  useViewDidFocusScreenAnalyticsEvent({
    key: 'checkDepositDeclined',
  });

  return (
    <View style={baseStyles.container} accessible>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText(
          'outcome.rejected.title',
          outcome.rejected.title,
        )}
        messageBody={
          errors.length > 0
            ? ''
            : translatedText(
                'outcome.rejected.message',
                outcome.rejected.message,
              )
        }
        content={<ContentList contentList={errors} />}
        primaryButton={{
          title: translatedText(
            'outcome.rejected.buttons.done',
            outcome.rejected.buttons.done,
          ),
          onPress: handleDoneAction,
          analytics: {
            analyticsId: 'goToHomeClicked',
            customAttributes: { source_name: 'mobile_check_declined' },
          },
        }}
      />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default DepositCheckRejectedView;
